import React, { useEffect, useMemo, useState } from "react"
import { useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Button, Card, Col, Container, Row } from "reactstrap"
import Logo from "../../../assets/images/logo.svg"
import phoneImg from "../../../assets/images/phone.svg"
import webImg from "../../../assets/images/web.svg"
import locationImg from "../../../assets/images/location.svg"
import moment from "moment"
import { downloadgrn, fetchGRN } from "../../../services/procurement/grn"
import parse from "html-react-parser"
import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import { fetchGrnCostingSingle } from "../../../services/finance/grnCosting"
import NumberFormat from "../../../utils/numberFormat"
import MobileNumberFormat from "../../../utils/mobilenumberformat"

const ViewCosting = ({ fromDashboard, viewValue }) => {
  const { id } = useParams()

  const viewId = fromDashboard ? viewValue?.value?.id : id

  const [grnDetails, setGrnDetails] = useState()
  const [tabledata, setTabledata] = useState()

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  useEffect(() => {
    const fetchGRNdata = async () => {
      const response = await fetchGrnCostingSingle(viewId)
      setGrnDetails(response?.data)
      setTabledata(response?.data?.grn?.grnquantitieslist)
    }
    if (viewId !== undefined) fetchGRNdata()
  }, [])

  const result = tabledata?.reduce(
    (acc, item) => {
      const received = item.received_quantity || 0
      return {
        totalreceived: Number(acc.totalreceived) + Number(received),
      }
    },
    { totalreceived: 0 }
  )

  const { totalreceived } = result || {}
  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard && "pt-0"}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between me-2">
            {!fromDashboard && (
              <Breadcrumbs
                title="Finance"
                breadcrumbObject={[
                  { title: "Finance", link: "/finance" },
                  { title: "GRN Costing", link: "/finance-grn-costing" },
                  {
                    title: "GRN Costing View",
                    link: `/finance-grn-costing/view/${viewId}`,
                  },
                ]}
              />
            )}
          </div>
          <Container fluid className="ps-lg-0">
            <Card className="supplier-card">
              <div className={`purchase-view-div ${fromDashboard && "wdt-96"}`}>
                <Row>
                  <Col>
                    <div className="d-flex justify-content-between me-2">
                      <h3 className="main-heading">GRN Costing</h3>
                      <img className="view-logo" src={Logo} alt="logo" />
                    </div>

                    <Row className=" pb-2 mt-3">
                      <Col lg="3">
                        <span>GRN Costing No</span>
                        <br />
                        <span className="fw-bold-700">{grnDetails?.code}</span>
                      </Col>
                      <Col lg="3">
                        <span>GRN No</span>
                        <br />
                        <span className="fw-bold-700">
                          {grnDetails?.grn?.grn_no}
                        </span>
                      </Col>
                      <Col lg="3">
                        <span>GRN Costing Date</span>
                        <br />
                        <span className="fw-bold-700">
                          {moment(grnDetails?.created_at).format("DD-MMM-YYYY")}
                        </span>
                      </Col>
                      <Col lg="3">
                        <span>PO NO</span>
                        <br />
                        <span className="fw-bold-700">
                          {grnDetails?.grn?.po?.purchase_orders_code}
                        </span>
                      </Col>
                    </Row>
                    <Row className=" pb-2 mt-3">
                      <Col lg="3">
                        <span>PO Date</span>
                        <br />
                        <span className="fw-bold-700">
                          {moment(grnDetails?.grn?.po?.created_at).format(
                            "DD-MMM-YYYY"
                          )}
                        </span>
                      </Col>
                      {/* <Col lg="3">
                        <span>Received Date </span>
                        <br />
                        <span className="fw-bold-700">
                          {moment(grnDetails?.recieved_date).format(
                            "DD-MMM-YYYY"
                          )}
                        </span>
                      </Col> */}
                      <Col lg="3">
                        <span>Received by</span>
                        <br />
                        <span className="fw-bold-700 capitalize-letter">
                          {grnDetails?.grn?.received_by}
                        </span>
                      </Col>
                      <Col lg="6">
                        <span>Supplier Name</span>
                        <br />
                        <span className="fw-bold-700">
                          {grnDetails?.grn?.po?.supplier?.name}
                        </span>
                      </Col>
                    </Row>
                    <div className="table_height">
                      <Row className="mt-4">
                        <Col lg={12}>
                          <h5 className="productDetail">Material Details</h5>
                        </Col>
                        <Col lg={12}>
                          <table className="estimation-table mb-4">
                            <thead>
                              <tr>
                                <th>S No</th>
                                <th>Product Code</th>
                                <th>Description</th>
                                <th className="text-end pe-4">Ordered Qty</th>
                                <th className="text-end pe-4">Rcvd.Qty</th>
                                <th className="text-end pe-4">Pend.Qty</th>
                              </tr>
                            </thead>
                            <tbody>
                              {tabledata?.map((data, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{data?.product?.product_code}</td>
                                    <td>{data.description} </td>
                                    <td className="text-end pe-4">{NumberFormat((Number(data.ordered_quantity)))}</td>
                                    <td className="text-end pe-4">{NumberFormat((Number( data.received_quantity)))}</td>
                                    <td className="text-end pe-4">{NumberFormat((Number(data.pending_quantity)))}</td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </Col>
                      </Row>
                      <div className="d-flex justify-content-between me-2">
                        <p className="quotation-ten-amount">
                          {grnDetails?.pay_terms &&
                            parse(grnDetails?.pay_terms)}
                        </p>
                        <p>
                          Total Qty Received{" "}
                          <span className="bg-total">{NumberFormat((Number(totalreceived)))}</span>
                        </p>
                      </div>
                    </div>

                    <div className="contact-us d-flex align-items-end justify-content-between text-blue border-top mt-5 py-3 font-size-12">
                      <div className="font-bold-800">Contact Us</div>
                      <div>
                        <img
                          src={phoneImg}
                          alt="location"
                          className="footer-logo"
                        />{" "}
                        {MobileNumberFormat("+" +  loggedUser?.settings?.phone)}
                      </div>
                      <div>
                        <img
                          src={webImg}
                          alt="location"
                          className="footer-logo"
                        />{" "}
                        {loggedUser?.settings?.website}
                      </div>
                      <div>
                        <img
                          src={locationImg}
                          alt="location"
                          className="footer-logo"
                        />{" "}
                        {loggedUser?.settings?.companyaddress}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              {/* {!fromDashboard && ( */}
              <Row>
                <Col lg={fromDashboard ? 12 : 8}>
                  <div
                    className={`d-flex justify-content-between me-2 ${
                      fromDashboard ? "pe-3" : "pr-50"
                    }`}
                  >
                    <span></span>
                    <Button
                      form={`supplier-form`}
                      color={"primary"}
                      className={"px-2 mb-3 btn btn-primary"}
                      onClick={() => downloadgrn(viewId, "grn.pdf")}
                    >
                      Download
                    </Button>
                  </div>
                </Col>
              </Row>
              {/* )} */}
            </Card>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ViewCosting
